import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-tags-management",
  "use": "icon-tags-management-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol viewBox=\"0 0 512 512\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-tags-management\"><path d=\"m176 150c24.813 0 45-20.187 45-45s-20.187-45-45-45-45 20.187-45 45 20.187 45 45 45zm0-60c8.271 0 15 6.729 15 15s-6.729 15-15 15-15-6.729-15-15 6.729-15 15-15z\" /><path d=\"m387.899 0h-263.798l-98.101 114.451v397.549h460v-397.549zm-11.899 482h-50v-367.549l-72.387-84.451h40.488l81.899 95.549zm-320-356.451 81.899-95.549h76.202l81.899 95.549v356.451h-240zm400 356.451h-50v-367.549l-72.387-84.451h40.488l81.899 95.549z\" /><path d=\"m86 180v272h180v-272zm150 242h-120v-212h120z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/tags-management.svg
// module id = 4EXG
// module chunks = 0